import React from "react";
import { formatCurrency } from "../../utils";

const AdTrackerConfirmationModel = ({
  isOpen,
  actionType,
  ppcSubscriptionDetail,
  onCancel,
  onConfirm,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const {isPaused = false,ppcRemainingBudget,adSpendForThisMonth,ppcAllocatedBudget,topUpRemaining=0} = ppcSubscriptionDetail;

  // Determine content based on action type and pause state
  const getContent = () => {

    // Default action if no over-utilization
if (actionType === "pause") {

      // If the remaining budget is exhausted, change the message and action
    if (adSpendForThisMonth >= ppcAllocatedBudget && topUpRemaining===0) {
      return {
        title: "Confirm Recharge to Resume",
        message: `Your ad budget has been exhausted to 100%. To resume the ad, please recharge an additional amount. This recharge is applicable only for the current billing cycle and will not be carried forward. Do you wish to proceed?`,
        confirmText: "Confirm",
        cancelText: "Cancel",
         buttonClass: "btn-primary"
      };
    }

      return {
        title: `Confirm ${isPaused ? "Resume" : "Pause"}`,
        message: isPaused
          ? "Resuming your ad will restart it in search results. You will be charged according to your billing cycle."
          : "Pausing your advertisement will prevent it from showing in search results until you either resume it or the next billing cycle begins. You will not incur charges during the pause period, but it will automatically resume in the next billing cycle, with a 30% upfront fee applied.",
        confirmText: `Yes, ${isPaused ? "Resume" : "Pause"} Ad`,
        cancelText: "No, Go Back",
        buttonClass: "btn-primary"
      };
  }else {
    if (ppcRemainingBudget < 0) {
      const overutilizedAmount = Math.abs(ppcRemainingBudget); // Get the absolute value of the overutilized amount
      return {
        title: "Confirm Cancellation",
        message: `Your ad has exceeded the deposited budget. You will be charged ${formatCurrency(
          overutilizedAmount
        )} immediately to cover the additional clicks beyond your prepaid deposit. Cancelling now will remove your ad tag from your facility and complete the billing for your current cycle usage. Do you wish to proceed with cancellation?`,
        confirmText: "Confirm & Charge",
        cancelText: "Cancel",
        buttonClass: "btn-danger"
      };
    }

    if (ppcRemainingBudget === 0) {
      return {
        title: "Confirm Cancellation",
        message: `There is no amount remaining for this ad promotion. Cancelling the plan will immediately remove the ad promotion. Are you sure you want to continue?`,
        confirmText: "Yes, Cancel Ad",
        cancelText: "No, Go Back",
        buttonClass: "btn-danger"
      };
    }

    return {
      title: "Confirm Cancellation",
      message: `Are you sure you want to cancel your ad for this facility? Your ad will continue running until your remaining deposit of ${formatCurrency(ppcRemainingBudget)} is fully utilized. Once canceled, this action cannot be undone. To run ads again, you will need to create a new ad campaign with a fresh deposit.`,
      confirmText: "Yes, Cancel Ad",
      cancelText: "No, Go Back",
      buttonClass: "btn-danger"
    };

  }

  };

  const { title, message, confirmText, cancelText } = getContent();

  return (
    <div className="modal upgrade-plan cancel-subscription-modal fade show change-subscription"
      id="exampleModal" tabIndex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="upgrade-plan-content">
            {title && <h4 className="modal-title">{title}</h4>}
            <span className="loading-msg">{message}</span>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="modal-btn"
              onClick={onCancel}
              disabled={isLoading}
            >
              {cancelText}
            </button>
            <button
              type="button"
              className={`modal-btn confirm-btn`}
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdTrackerConfirmationModel;